import React, { useState, useEffect } from 'react';
import './EditarTarjeta.css';
import { ReactComponent as Volver } from '../assets/icon/volver.svg';
import { useNavigate, useParams } from "react-router-dom";
import CalendarInicioTarjetas from './CalendarInicioTarjetas';
import CalendarFinTarjetas from './CalendarFinTarjetas';
import { getTarjetaByNumero, updateTarjeta } from '../services/tarjetas';

function EditarTarjeta() {
    const navigate = useNavigate();
    const { numeroTarjeta } = useParams();
    
    const [formData, setFormData] = useState({
        fechaCreacion: '',
        anioVencimiento: '',
        mesVencimiento: '',
        tipoTarjeta: '',
        estatus: '',
        idCliente: ''
    });
    
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTarjeta = async () => {
            if (!numeroTarjeta) {
                setLoading(false);
                return;
            }
            
            try {
                const decodedNumero = decodeURIComponent(numeroTarjeta);
                const result = await getTarjetaByNumero(decodedNumero);
                
                if (result.success && result.data) {
                    const tarjeta = result.data;
                    setFormData({
                        fechaCreacion: tarjeta.Fecha_creacion || tarjeta.fechaCreacion || '',
                        anioVencimiento: tarjeta.AnioVencimiento || tarjeta.anioVencimiento || '',
                        mesVencimiento: tarjeta.MesVencimiento || tarjeta.mesVencimiento || '',
                        tipoTarjeta: tarjeta.TipoTarjeta || tarjeta.tipoTarjeta || '',
                        estatus: tarjeta.Estatus || tarjeta.estatus || 'Activa',
                        idCliente: tarjeta.IdCliente || tarjeta.idCliente || ''
                    });
                }
            } catch (err) {
                setError('Error al cargar los datos de la tarjeta');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        
        fetchTarjeta();
    }, [numeroTarjeta]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError(null);
        
        try {
            const decodedNumero = decodeURIComponent(numeroTarjeta);
            const result = await updateTarjeta(decodedNumero, formData);
            
            if (result.success) {
                alert('Tarjeta actualizada exitosamente');
                navigate("/dashboard/tarjetas");
            } else {
                setError(result.mensaje || 'Error al actualizar la tarjeta');
            }
        } catch (err) {
            setError('Error al actualizar la tarjeta');
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className='bodyEditarTarjetas'>
                <div className='tituloEditarTarjetas'><p>-Editar Tarjeta</p></div>
                <div className="loading-container">
                    <p>Cargando datos de la tarjeta...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='bodyEditarTarjetas'>

            {/* TÍTULO */}
            <div className='tituloEditarTarjetas'><p>-Editar Tarjeta</p></div>
            <div className='cuerpoBotonVolverTarjetas'>
                <button
                    className='botonesEditarTarjetas'
                    onClick={() => navigate("/dashboard/tarjetas")}
                >
                    <div className="svgBotones"><Volver className="logo-svgBotones" /></div>
                    Volver
                </button>
            </div>

            <div className='cuerpoEditarTarjetas'>
                {error && (
                    <div className="error-message" style={{ marginBottom: '16px', padding: '12px', background: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
                        {error}
                    </div>
                )}
                
                {/* INPUTS */}
                <form onSubmit={handleSubmit} className='inputsTarjetas'>

                    {/* Número de tarjeta (solo lectura) */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>Número de tarjeta</label>
                        </div>
                        <input
                            className="inputEditarTarjetas"
                            type="text"
                            value={numeroTarjeta ? decodeURIComponent(numeroTarjeta) : ''}
                            disabled
                            style={{ background: '#f5f5f5' }}
                        />
                    </div>

                    {/* ID Cliente */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>ID Cliente</label>
                        </div>
                        <input
                            className="inputEditarTarjetas"
                            type="text"
                            name="idCliente"
                            value={formData.idCliente}
                            onChange={handleChange}
                            placeholder="ID del cliente"
                        />
                    </div>

                    {/* Fecha de creación */}
                    <div className='calendario'>
                        <CalendarInicioTarjetas 
                            onSelect={(date) => setFormData(prev => ({ ...prev, fechaCreacion: date }))}
                            selectedDate={formData.fechaCreacion}
                        />
                        <div className="contadorFantasma">0/30</div>
                    </div>

                    {/* Mes de vencimiento */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>Mes de vencimiento</label>
                        </div>
                        <select
                            className="inputEditarTarjetas"
                            name="mesVencimiento"
                            value={formData.mesVencimiento}
                            onChange={handleChange}
                        >
                            <option value="">Seleccionar mes</option>
                            {Array.from({ length: 12 }, (_, i) => {
                                const month = String(i + 1).padStart(2, '0');
                                return (
                                    <option key={month} value={month}>{month}</option>
                                );
                            })}
                        </select>
                    </div>

                    {/* Año de vencimiento */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>Año de vencimiento</label>
                        </div>
                        <select
                            className="inputEditarTarjetas"
                            name="anioVencimiento"
                            value={formData.anioVencimiento}
                            onChange={handleChange}
                        >
                            <option value="">Seleccionar año</option>
                            {Array.from({ length: 15 }, (_, i) => {
                                const year = String(new Date().getFullYear() + i);
                                return (
                                    <option key={year} value={year}>{year}</option>
                                );
                            })}
                        </select>
                    </div>

                    {/* Tipo de tarjeta */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>Tipo de tarjeta</label>
                        </div>
                        <select
                            className="inputEditarTarjetas"
                            name="tipoTarjeta"
                            value={formData.tipoTarjeta}
                            onChange={handleChange}
                        >
                            <option value="">Seleccionar tipo</option>
                            <option value="VISA">VISA</option>
                            <option value="MASTERCARD">MASTERCARD</option>
                            <option value="AMEX">AMEX</option>
                            <option value="credito">Crédito</option>
                            <option value="debito">Débito</option>
                        </select>
                    </div>

                    {/* Estatus */}
                    <div className="input-groupEditarTarjetas">
                        <div className='text-inputEditarTarjetas'>
                            <label>Estatus</label>
                        </div>
                        <select
                            className="inputEditarTarjetas"
                            name="estatus"
                            value={formData.estatus}
                            onChange={handleChange}
                        >
                            <option value="Activa">Activa</option>
                            <option value="Inactiva">Inactiva</option>
                            <option value="Bloqueada">Bloqueada</option>
                            <option value="Cancelada">Cancelada</option>
                        </select>
                    </div>

                    {/* Botones */}
                    <div className='botonesEditarTarjetas2'>
                        <button 
                            type="submit" 
                            className="btn-acceptGuardarTarjetas"
                            disabled={saving}
                        >
                            {saving ? 'Guardando...' : 'Guardar'}
                        </button>
                        <button 
                            type="button" 
                            className="btn-acceptConfirmarTarjetas"
                            onClick={() => navigate("/dashboard/tarjetas")}
                            disabled={saving}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditarTarjeta;
